<main class="map-shell">
  <div class="floating-toolbar">
    <strong>a2a</strong>
    <span>Agent connection map</span>
    <button type="button" (click)="zoomIn()">+</button>
    <em>{{ (zoom * 100) | number:'1.0-0' }}%</em>
    <button type="button" (click)="zoomOut()">-</button>
    <button type="button" (click)="resetView()">Reset</button>
    <button type="button" (click)="fitView()">Fit</button>
  </div>

  <aside class="status-dock">
    <section>
      <p>WebSocket</p>
      <strong [class.good]="socketStatus === 'connected'">{{ socketStatus }}</strong>
    </section>
    <section>
      <p>Canal</p>
      <strong [class.good]="channelConnected">{{ state?.channelStatus || 'disconnected' }}</strong>
    </section>
    <section>
      <p>Agentes</p>
      <strong>{{ connectedAgents().length }} / {{ availableAgents().length }}</strong>
    </section>
    <section>
      <p>Mensajes</p>
      <strong>{{ totalMessageCount }}</strong>
    </section>
  </aside>

  <section
    class="canvas"
    (wheel)="onCanvasWheel($event)"
    (mousedown)="startPan($event)"
    (mousemove)="movePan($event)"
    (mouseup)="endPan()"
    (mouseleave)="endPan()"
  >
    <div class="stage" [style.transform]="'translate(' + panX + 'px,' + panY + 'px) scale(' + zoom + ')'">
      <svg class="links-layer" viewBox="0 0 2000 1300" preserveAspectRatio="none">
        <defs>
          <filter id="glow">
            <feGaussianBlur stdDeviation="3" result="blur"></feGaussianBlur>
            <feMerge>
              <feMergeNode in="blur"></feMergeNode>
              <feMergeNode in="SourceGraphic"></feMergeNode>
            </feMerge>
          </filter>
          <filter id="glow-strong">
            <feGaussianBlur stdDeviation="5" result="blur"></feGaussianBlur>
            <feMerge>
              <feMergeNode in="blur"></feMergeNode>
              <feMergeNode in="SourceGraphic"></feMergeNode>
            </feMerge>
          </filter>
        </defs>

        <!-- Hub rings centered on IA Directory -->
        <circle [attr.cx]="hubCX" [attr.cy]="hubCY" r="220" class="hub-ring hub-ring-inner" [class.active]="channelConnected"></circle>
        <circle [attr.cx]="hubCX" [attr.cy]="hubCY" r="380" class="hub-ring hub-ring-outer" [class.active]="channelConnected"></circle>

        <g *ngFor="let link of graphConnections(); trackBy: trackByConnection">
          <path
            class="map-link"
            [class.active]="link.active"
            [class.auth]="link.kind === 'auth'"
            [class.http]="link.kind === 'http'"
            [class.agent]="link.kind === 'agent'"
            [class.db]="link.kind === 'db'"
            [class.event]="link.kind === 'event'"
            [attr.d]="connectionPath(link)"
          ></path>
          <text
            *ngIf="link.count"
            class="link-count"
            [attr.x]="connectionMid(link).x"
            [attr.y]="connectionMid(link).y"
          >{{ link.count }}</text>
        </g>
      </svg>

      <article
        *ngFor="let node of graphNodes(); trackBy: trackByNode"
        class="map-node"
        [ngClass]="[node.type, node.status]"
        [class.compact]="node.compact"
        [class.selected]="selectedAgentId && node.agentId === selectedAgentId"
        [style.left.px]="node.x"
        [style.top.px]="node.y"
        [style.width.px]="node.w"
        [style.minHeight.px]="node.h"
        (click)="node.agentId ? selectAgent(node.agentId) : null"
      >
        <!-- Compact agent card (radial orbit) -->
        <ng-container *ngIf="node.compact">
          <header class="compact-header">
            <div class="compact-status-dot" [class.dot-online]="node.status === 'online'" [class.dot-down]="node.status === 'down'"></div>
            <div class="compact-titles">
              <h2>{{ node.title }}</h2>
              <small>{{ node.subtitle }}</small>
            </div>
            <b>{{ node.status }}</b>
          </header>
        </ng-container>

        <!-- Directory hub card -->
        <ng-container *ngIf="node.type === 'directory'">
          <header>
            <div>
              <span>HUB · DIRECTORY</span>
              <h2>{{ node.title }}</h2>
            </div>
            <b>{{ node.status }}</b>
          </header>
          <div class="hub-stats-grid">
            <div><span>Total agentes</span><strong>{{ availableAgents().length }}</strong></div>
            <div><span>Online</span><strong class="stat-online">{{ connectedAgents().length }}</strong></div>
            <div><span>Offline</span><strong class="stat-offline">{{ availableAgents().length - connectedAgents().length }}</strong></div>
            <div><span>Eventos</span><strong>{{ totalMessageCount }}</strong></div>
            <div><span>WebSocket</span><strong [class.stat-online]="socketStatus === 'connected'">{{ socketStatus }}</strong></div>
            <div><span>Canal A2A</span><strong [class.stat-online]="channelConnected">{{ state?.channelStatus || 'disconnected' }}</strong></div>
          </div>
          <div class="hub-agent-dots" *ngIf="connectedAgents().length">
            <span *ngFor="let a of connectedAgents().slice(0, 10)" class="hub-dot" [title]="a.name"></span>
            <span *ngIf="connectedAgents().length > 10" class="hub-dot-more">+{{ connectedAgents().length - 10 }}</span>
          </div>
        </ng-container>
      </article>
    </div>
  </section>

  <aside class="events-feed" *ngIf="recentEvents.length">
    <h3>Actividad reciente</h3>
    <div class="event-row" *ngFor="let ev of recentEvents.slice(0, 7)" [class.is-connected]="ev.action === 'connected'">
      <span class="event-dot"></span>
      <div class="event-info">
        <strong>{{ ev.name }}</strong>
        <small>{{ ev.action === 'connected' ? '↑ conectado' : '↓ desconectado' }}</small>
      </div>
      <time>{{ formatTime(ev.time) }}</time>
    </div>
  </aside>

  <aside class="legend">
    <h3>Estado</h3>
    <div><i class="dot-legend online-dot"></i><span>Online / conectado</span></div>
    <div><i class="dot-legend offline-dot"></i><span>Offline / desconectado</span></div>
    <div style="margin-top:10px"><i class="agent"></i><span>Conexion activa</span></div>
    <div><i class="event"></i><span>Sin conexion</span></div>
  </aside>

  <aside class="right-drawer" *ngIf="selectedAgent() as agent">
    <header>
      <div>
        <p>Seleccionado</p>
        <h2>{{ agent.name }}</h2>
      </div>
      <span [class.good]="agent.connected">{{ agent.connected ? 'online' : 'down' }}</span>
    </header>

    <dl>
      <div>
        <dt>ID</dt>
        <dd>{{ agent.agentId }}</dd>
      </div>
      <div>
        <dt>Direccion</dt>
        <dd>
          <code>{{ connectionLabel(agent) }}</code>
          <button type="button" (click)="copy(agent.connectionId || agent.agentId)">Copiar</button>
        </dd>
      </div>
      <div>
        <dt>Actividad</dt>
        <dd>{{ agent.activity }}</dd>
      </div>
      <div>
        <dt>Descripcion</dt>
        <dd>{{ agent.description || agent.specialty || agent.purpose }}</dd>
      </div>
    </dl>

    <section class="drawer-block">
      <h3>Mensajes recientes</h3>
      <article *ngFor="let message of agentMessages(agent.agentId)">
        <strong>{{ message.fromName }} -> {{ message.toName }}</strong>
        <p>{{ compact(message.content, 120) }}</p>
      </article>
      <p *ngIf="!agentMessages(agent.agentId).length">Sin mensajes recientes.</p>
    </section>

    <section class="drawer-block">
      <h3>Consultas Decision Agent</h3>
      <article *ngFor="let query of agentQueries(agent.agentId)">
        <strong>{{ query.requester }} -> {{ query.selectedAgent || 'sin seleccion' }}</strong>
        <p>{{ compact(query.reason || query.task, 120) }}</p>
      </article>
      <p *ngIf="!agentQueries(agent.agentId).length">Sin consultas recientes.</p>
    </section>
  </aside>

  <section class="bottom-console">
    <div class="console-form">
      <label>
        Tarea
        <input [(ngModel)]="topic" (ngModelChange)="saveSettings()" name="topic">
      </label>
      <label>
        OpenAI key
        <input [(ngModel)]="apiKey" (ngModelChange)="saveApiKey()" name="apiKey" type="password" placeholder="sk-...">
      </label>
      <label>
        Pasos
        <input [(ngModel)]="maxTurns" (ngModelChange)="saveSettings()" name="maxTurns" type="number" min="1" max="100">
      </label>
    </div>
    <div class="console-actions">
      <button type="button" (click)="connectChannel()" [disabled]="channelConnected">Conectar canal</button>
      <button type="button" (click)="start()" [disabled]="busy || !channelConnected">Iniciar gestion</button>
      <button type="button" (click)="step()" [disabled]="state?.status !== 'running' || !!state?.typingAgent">Paso</button>
      <button type="button" (click)="setAuto(!state?.auto)" [disabled]="state?.status !== 'running'">{{ state?.auto ? 'Pausar' : 'Auto' }}</button>
      <button type="button" class="danger" (click)="finish()" [disabled]="state?.status !== 'running'">Finalizar</button>
    </div>
  </section>

  <p class="error-toast" *ngIf="error">{{ error }}</p>
</main>
